import React, { useState, useEffect } from "react";
import { FaTimes } from "react-icons/fa";

const SEEN_KEY = "champawati-popup-seen";

// One notice at a time, shown once per visit, with a close button that is
// easy to hit on a phone.
const Popup = () => {
	const [items, setItems] = useState([]);
	const [index, setIndex] = useState(0);
	const [open, setOpen] = useState(false);

	useEffect(() => {
		let seen = false;
		try {
			seen = sessionStorage.getItem(SEEN_KEY) === "1";
		} catch (error) {
			seen = false;
		}
		if (seen) return;
		fetch("/api/popup/")
			.then((res) => res.json())
			.then((data) => {
				if (Array.isArray(data) && data.length > 0) {
					setItems(data);
					setOpen(true);
				}
			})
			.catch((error) => console.log(error));
	}, []);

	const close = () => {
		setOpen(false);
		try {
			sessionStorage.setItem(SEEN_KEY, "1");
		} catch (error) {
			// Storage is blocked: the notice may show again on the next visit
		}
	};

	if (!open || items.length === 0) return null;
	const item = items[index];

	return (
		<div className='pp-back' onClick={close} role='presentation'>
			<div
				className='pp'
				role='dialog'
				aria-modal='true'
				aria-label='Notice'
				onClick={(event) => event.stopPropagation()}
			>
				<div className='pp-head'>
					<span>
						Notice {index + 1} of {items.length}
					</span>
					<button
						type='button'
						className='pp-close'
						onClick={close}
						aria-label='Close notice'
					>
						<FaTimes />
					</button>
				</div>
				<div className='pp-body'>
					{item.image && <img src={item.image} alt={item.text || "Notice"} />}
					{item.text ? <p>{item.text}</p> : null}
				</div>
				{items.length > 1 && (
					<div className='pp-foot'>
						<button
							type='button'
							onClick={() => setIndex(index - 1)}
							disabled={index === 0}
						>
							Previous
						</button>
						<button
							type='button'
							onClick={() => setIndex(index + 1)}
							disabled={index === items.length - 1}
						>
							Next
						</button>
					</div>
				)}
			</div>
		</div>
	);
};

export default Popup;
